module.exports = __webpack_public_path__ + "grape_instant_shop-5346a.svg";